module.exports = __webpack_public_path__ + "img/Eselei.f6d8d256.svg";